<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="外销合同编号：" v-if="hideQuery.indexOf('orderCode')==-1">
        <el-input size="mini" v-model="dataForm.orderCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="外销合同编号：" v-if="hideQuery.indexOf('fuzzyOrderCode')==-1">
        <el-input size="mini" v-model="dataForm.fuzzyOrderCode" clearable></el-input>
      </el-form-item>
      <el-form-item prop="productCode" label="品番号：">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
            style="width: 240px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
            style="width: 240px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" label="品名：">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
            style="width: 240px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="请输入颜色"
            style="width: 200px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="请输入规格"
            style="width: 200px;"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini" type="primary">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="showSendDialog()" v-if="queryType==='seller'" size="mini" type="warning">发货</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="showPriceEditDialog()" v-if="queryType==='seller'" size="mini" type="warning">费用调整</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="showReceiveDialog()" v-if="queryType==='receiver'" size="mini" type="warning">确认收货
        </el-button>
      </el-form-item>

    </el-form>
    <div class="table-bar" style="justify-content: left;margin-bottom: 0px;">
    </div>
    <SweetTable ref="table" :selection="true" api-version="v2" url="/erp/make/detail/page"
                :query-form="dataForm" :before-table-binding="beforeTableBinding" :auto-load="false" :summaries-column="['count','sendCount','receiveCount','totalSendCount']">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="sellerName"
          label="发货方"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          v-if="queryType==='receiver'"
      ></el-table-column>
<!--      <el-table-column-->
<!--          prop="receiver"-->
<!--          label="收货方"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--          :show-overflow-tooltip="true"-->
<!--          v-if="queryType==='seller'"-->
<!--      >-->
<!--      </el-table-column>-->
      <el-table-column
          prop="product.code"
          label="品番号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.skuCode"
          label="SKU"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.nameZh"
          label="中文品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="makeType"
          label="产品类型"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          prop="amount"
          label="加工费"
          header-align="center"
          align="center"
          width="120"
          v-if="queryType==='seller'"
      >
      </el-table-column>
      <el-table-column
          label="纸箱"
          header-align="center"
          align="center"
          prop="packPrice"
          width="90"
          v-if="queryType==='seller'"
      >
      </el-table-column>
      <el-table-column
          label="中棉"
          header-align="center"
          align="center"
          prop="cottonPrice"
          width="90"
          v-if="queryType==='seller'"
      >
      </el-table-column>
      <el-table-column
          label="运费"
          header-align="center"
          align="center"
          prop="freightPrice"
          width="90"
          v-if="queryType==='seller'"
      >
      </el-table-column>
      <el-table-column
          prop="totalPrice"
          label="单价小计"
          header-align="center"
          align="center"
          width="120"
          v-if="queryType==='seller'"
      >
      </el-table-column>
      <el-table-column
          prop="count"
          label="计划数"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          prop="waitReceiveCount"
          label="待收货"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          label="已收货"
          header-align="center"
          align="center"
          prop="sendCount"
          width="120"
      >
      </el-table-column>
      <el-table-column
          prop="totalSendCount"
          label="总发货数"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          prop="totalAmount"
          label="合计金额(已发货)"
          header-align="center"
          align="center"
          width="140" fixed="right"
      >
      </el-table-column>
    </SweetTable>
    <ReceiveDialog ref="ReceiveDialog" @change="getDataList"></ReceiveDialog>
    <ProductSendDialog ref="ProductSendDialog" @change="getDataList"></ProductSendDialog>
    <MakePriceEditDialog ref="MakePriceEditDialog" @change="getDataList"></MakePriceEditDialog>
  </div>
</template>

<script>
import MakePriceEditDialog from '@/views/modules/erp/client/MakePriceEditDialog.vue'
import ReceiveDialog from '@/views/modules/erp/client/common/receive-dialog'
import SweetTable from '@/mixins/SweetTable'
import ProductSendDialog from '@/components/ProductSendDialog.vue'
import BigNumber from 'bignumber.js'
import moment from 'moment'
export default {
  mixins: [SweetTable],
  components: { ReceiveDialog, ProductSendDialog,MakePriceEditDialog },
  props: {
    queryType: {
      type: String,
      default: ''
    },
    hideQuery: {
      type:Array,
      default: ()=>[]
    }
  },
  data () {
    return {
      dateArr: [],
      dataForm: {
        fuzzyOrderCode:'',
        queryType: '',
        orderCode: '',
        sellerName: '',
        receiverName: '',
        productCode: '',
        skuCode: '',
        productName: '',
        productColor: '',
        productSize: '',
      },
    }
  },
  watch: {
    queryType: {
      handler: function (newVal, oldVal) {
        this.dataForm.queryType = newVal
        if (!this.dataForm.queryType) {
          return
        }
        this.reload()
      }
      , immediate: true
    },

  },
  methods: {
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.waitReceiveCount = new BigNumber(row.totalSendCount).minus(row.sendCount).toFixed(3).replace(/\.?0+$/, '')
        row.totalAmount = new BigNumber(row.totalPrice).multipliedBy(row.sendCount).toFixed(2)
      })
    },
    showSendDialog () {
      let selData = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(selData)) {
        return this.$message.error('请选择要发货的订单记录')
      }
      let sendData = selData.map(item => {
        return {
          sourceId: item.id,
          makeDetailId: item.id,
          planCount: item.count,
          totalPrice: item.totalPrice,
          makeType: item.makeType,
          product: item.product,
          orderCode: item.orderCode,
          sellerName: item.sellerName,
          receiverName: item.receiverName,
          totalSendCount: item.totalSendCount,
          operateTime:moment().format('YYYY-MM-DD')
        }
      })
      this.$refs.ProductSendDialog.init(sendData)
    },
    showPriceEditDialog(){
      let selData = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(selData)) {
        return this.$message.error('请选择要调整的订单记录')
      }
      let data = selData.map(item => {
        return {
          id: item.id,
          planCount: item.count,
          totalPrice: item.totalPrice,
          makeType: item.makeType,
          product: item.product,
          orderCode: item.orderCode,
          packPrice: item.packPrice,
          cottonPrice: item.cottonPrice,
          freightPrice: item.freightPrice
        }
      })
      this.$refs.MakePriceEditDialog.init(data)
    },
    showReceiveDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择收货内容')
      }
      let queryParams = rows.map(item => {
        return {
          sourceId: item.id,
          sourceType: 'make'
        }
      })
      //根据原始订单信息读取要收货的明细
      this.$api2.post(`/trade/factorystorelog/query/list/for-receive`, queryParams).then(res => {
        if (res) {
          res.forEach(item => {
            item.receiveCount = item.sendCount
          })
        }
        this.$refs.ReceiveDialog.init(res)
      })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
